import { useEffect, useState } from 'react';
import { AllUser } from '@/interfaces/user';
import {
  getAccessTokenFromRefreshToken,
  getUserByToken,
} from '@/services/userService';
import { getDynamicEnvVarsInClient } from '@/utils/envHelper';
import { getCookie, setCookie } from 'cookies-next';

const useCheckIsAuthenticatedUser = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState<AllUser | null>();

  const { NEXT_PUBLIC_CW_AUTH_URL } = getDynamicEnvVarsInClient();

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const accessToken = getCookie('accessToken');
        const refreshToken = getCookie('refreshToken');
        const tenantName = getCookie('tenantName') as string;
        const tenantId = getCookie('tenantId') as string;
        const app_id = getCookie('app_id') as string;

        if (accessToken) {
          try {
            const user = await getUserByToken(
              tenantId,
              tenantName,
              accessToken,
              NEXT_PUBLIC_CW_AUTH_URL
            );
            setUserInfo(user);
            setIsAuthenticated(true);
          } catch (error: any) {
            if (error.response && error.response.status === 401) {
              // Access token expired, try to refresh
              if (refreshToken) {
                try {
                  const response = await getAccessTokenFromRefreshToken(
                    refreshToken,
                    NEXT_PUBLIC_CW_AUTH_URL,
                    app_id
                  );
                  const newAccessToken = response.accessToken;
                  const newRefreshToken = response.refreshToken;

                  setCookie('accessToken', newAccessToken);
                  setCookie('refreshToken', newRefreshToken);

                  const user = await getUserByToken(
                    tenantId,
                    tenantName,
                    accessToken,
                    NEXT_PUBLIC_CW_AUTH_URL
                  );
                  setUserInfo(user);
                  setIsAuthenticated(true);
                } catch (error) {
                  console.error('Error refreshing access token:', error);
                }
              } else {
                console.error('No refresh token available');
              }
            } else {
              console.error('Error fetching user details:', error);
            }
          }
        } else {
          setIsAuthenticated(false);
          setUserInfo(null);
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthentication();
  }, []);

  return { isLoading, isAuthenticated, userInfo };
};

export default useCheckIsAuthenticatedUser;
